export { default as dayJs } from './day-js';
